var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTwitterMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5992 10.1954H11.1602L22.3871 26.2545H24.8262L13.5992 10.1954Z",
    fill: "#6B47F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18C0 8.056 8.056 0 18 0C27.944 0 36 8.056 36 18C36 27.944 27.944 36 18 36C8.056 36 0 27.944 0 18ZM26.4133 9L19.7124 16.7892L27 27.3955H21.6401L16.7324 20.2533L10.588 27.3955H9L16.0274 19.2273L9 9H14.3599L19.007 15.7633L24.8255 9H26.4133Z",
    fill: "#6B47F5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitterMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter_mobile.69d7b9be.svg";
export { ForwardRef as ReactComponent };